<template>
    <div class="animation_input">
        <input :type="typeC" :value="modelValue" :id="name" :maxlength="maxlength" @input="handleInput" />
        <label class="label_name" :class="modelValue ? 'small' : ''" :for="name">{{ placeholder }}</label>
        <div class="password_view" v-if="type === 'password'" @click="passwordIsView = !passwordIsView">
            <i class="iconfont icon-mimaxianshi" v-show="!passwordIsView"></i>
            <i class="iconfont icon-xs" v-show="passwordIsView"></i>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from "vue";

const props = defineProps({
    modelValue: { type: String, default: "" },
    type: { type: String, default: "text" },
    name: { type: String, requied: true },
    placeholder: { type: String, default: "" },
    autoFocus: { type: Boolean, default: false },
    maxlength: { type: String || Number, default: "" },
});
const emit = defineEmits(["update:modelValue"]);
const val = ref(null);
const passwordIsView = ref(false); // 密码类型时是否显示原文
const typeC = computed(() => {
    let res = props.type;
    if (props.type === "password" && passwordIsView.value) {
        res = "text";
    }
    return res;
});

function handleInput(e) {
    val.value = e.target.value;
    emit("update:modelValue", val.value);
}

onMounted(() => {
    if (props.autoFocus) {
        const dom = document.querySelector("#" + props.name);
        nextTick(() => {
            dom && dom.focus();
        });
    }
});
</script>

<style lang="scss" scoped>
.animation_input {
    width: 100%;
    position: relative;
    border-bottom: 1px solid #d8d8d8;
    height: 68px;
    transition: all 0.3s linear;

    &:has(input:focus) {
        border-bottom: 2px solid var(--week-primary-color);
    }

    .label_name {
        position: absolute;
        left: 5px;
        top: 20px;
        font-size: 16px;
        color: #727272;
        transition: all 0.3s linear;
        cursor: text;

        &.small {
            top: 0;
            left: 0;
            font-size: 14px;
        }
    }

    input {
        width: 100%;
        height: 50px;
        position: absolute;
        left: 0;
        bottom: 0;
        background: none;
        border: none;
        font-size: 16px;
        padding: 0 5px;
        color: #727272;

        &:focus {
            & + .label_name {
                top: 0;
                left: 0;
                color: var(--week-primary-color);
                font-size: 14px;
            }
        }

        /* 去掉填充后的背景色*/
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
            -webkit-transition-delay: 111111s;
            -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
        }
    }

    .password_view {
        position: absolute;
        right: 0;
        bottom: 10px;
        cursor: pointer;
        .iconfont {
            font-size: 20px;
        }
    }

    .code_img {
        width: 90px;
        height: 32px;
        border: 1px solid #d9d9d9;
        position: absolute;
        bottom: 10px;
        right: 0;
        cursor: pointer;
    }
}
</style>
